module.exports = __webpack_public_path__ + "static/media/4_shpok_a.c9e089dd.ogg";